import { ClockIcon, Link01Icon } from '@langchain/untitled-ui-icons';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

import { CopyInlineLink } from '@/components/CopyInlineLink';
import { EPromptOptimizationJobStatus } from '@/types/schema';
import { cn } from '@/utils/tailwind';

import { getStatusLabel, getStyleFromStatus } from './utils';

dayjs.extend(duration);
dayjs.extend(relativeTime);

export const Chip = ({
  content,
  style,
}: {
  content: string | JSX.Element;
  style?: string;
}) => (
  <div
    className={cn(
      'h-fit w-fit rounded-full border px-2 py-0.5 text-xs font-medium',
      style ?? 'border-secondary bg-[#F9FAFB] text-[#344054]'
    )}
  >
    {content}
  </div>
);

export const DurationChip = ({
  startTime,
  endTime,
}: {
  startTime: string;
  endTime: string;
}) => (
  <Chip
    content={
      <div className="flex flex-row gap-1.5">
        {dayjs
          .duration(dayjs(endTime).diff(dayjs(startTime)))
          .format('m [mins] s [secs]')}
        <ClockIcon className="my-auto h-4 w-4 text-[#667085]" />
      </div>
    }
  />
);

export const StatusChip = ({
  status,
}: {
  status: EPromptOptimizationJobStatus;
}) => (
  <Chip content={getStatusLabel(status)} style={getStyleFromStatus(status)} />
);

export const IDChip = ({ value }: { value: string }) => (
  <CopyInlineLink
    icon={<></>}
    value={value}
    disableDefaultClasses
    className="cursor-pointer"
  >
    <Chip
      content={
        <div className="flex flex-row gap-1.5">
          <span>ID</span>
          <Link01Icon className="h-4 w-4 text-[#667085]" />
        </div>
      }
    />
  </CopyInlineLink>
);
